export default function resourceDownloads() {
	const panels = document.querySelectorAll('div.resource-downloads__panel');
	panels.forEach((panel) => {
		let trigger = panel.querySelector('h5.resource-downloads__product-name');
		if (trigger instanceof HTMLElement) {
			trigger.addEventListener('click', () => {
				panel.classList.toggle('resource-downloads__panel--active');
			});
		}
	});
}
